import { List, Record } from 'immutable';
import { RoomTypeRateSummary } from './room-type-rate-summary';
import { StaySummary } from 'app/event/models/stay-summary';

const RoomStaySummaryRecord = Record({
  roomTypeRateSummaryList: null,
  staySummary: null
});

export class RoomStaySummary extends RoomStaySummaryRecord {
  roomTypeRateSummaryList: List<RoomTypeRateSummary>;
  staySummary: StaySummary;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/room-stay-summary.ts